<script>
import { mapState } from "vuex";

export default {
	name: "compKematianDetail",
	data() {
		return {};
	},
	computed: {
		isLoading() {
			return this.$store.state.isLoading;
		},
		...mapState({
			umatKematianItem: (state) => state.umatKematian.item,
		}),
	},
};
</script>

<template>
<table class="table table-striped table-hover text-left">
					<tbody>
						<tr>
							<td>Tanggal Meninggal</td>
							<td>:</td>
							<td>{{ umatKematianItem.tgl_meninggal_human }}</td>
						</tr>
						<tr>
							<td>Tempat Meninggal</td>
							<td>:</td>
							<td>{{ umatKematianItem.tempat_meninggal }}</td>
						</tr>
					</tbody>
				</table>
</template>

